import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=485f5590&"
import script from "./forum.vue?vue&type=script&lang=js&"
export * from "./forum.vue?vue&type=script&lang=js&"
import style0 from "./forum.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports